module.exports = __webpack_public_path__ + "img/logo14.ec3580e0.png";